import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { ProjectConfigService } from '../services/project-config.service';

@Injectable({
  providedIn: 'root'
})
export class UnderConstructionGuard implements CanActivate {

  constructor(
    private projectConfigService: ProjectConfigService,
    private router: Router
  ) {}

  canActivate(): boolean {
    const config = this.projectConfigService.getConfig();
    if (config.underConstruction) {
      this.router.navigate(['/under-construction']);
      return false;
    }
    return true;
  }
}
